import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'onlyDate',
  standalone: true,
})
export class OnlyDate implements PipeTransform {
  transform(value: string, withTime = false): string {
    let result = value?.split('T')[0];
    if (withTime) {
      result = value?.split('.')[0];
    }
    return result || value;
  }
}
